import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./gallery.module.css";

const Gallery = () => (
  <section id="gallery" className="section-wrapper">
    <h2 className="section-title">
      <a href="#gallery">Gallery</a>
    </h2>
    <div className={styles.galleryImages}>
      <StaticImage
        src="../../images/gallery/gallery_1.png"
        alt="Gallery Image 1"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
      <StaticImage
        src="../../images/gallery/gallery_2.png"
        alt="Gallery Image 2"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
      <StaticImage
        src="../../images/gallery/gallery_3.png"
        alt="Gallery Image 3"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
      <StaticImage
        src="../../images/gallery/gallery_4.png"
        alt="Gallery Image 4"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
      <StaticImage
        src="../../images/gallery/gallery_5.png"
        alt="Gallery Image 5"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
      <StaticImage
        src="../../images/gallery/gallery_6.png"
        alt="Gallery Image 6"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
      <StaticImage
        src="../../images/gallery/gallery_7.png"
        alt="Gallery Image 7"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
      <StaticImage
        src="../../images/gallery/gallery_8.png"
        alt="Gallery Image 8"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
      <StaticImage
        src="../../images/gallery/gallery_9.png"
        alt="Gallery Image 9"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
      <StaticImage
        src="../../images/gallery/gallery_10.png"
        alt="Gallery Image 10"
        placeholder="blurred"
        className={styles.galleryImageItem}
      />
    </div>
  </section>
);

export default Gallery;
